import { COPY, JUDGMENTS } from '../data/copy.js';

export default class Hud {
  constructor() {
    this.root = document.getElementById('screen-hud');
    this.scoreEl = document.getElementById('hud-score');
    this.comboEl = document.getElementById('hud-combo');
    this.fillEl = document.getElementById('hud-progress-fill');
    this.overdriveFillEl = document.getElementById('overdrive-fill');
    this.overdriveLabelEl = document.getElementById('overdrive-label');
    this.eraEl = document.getElementById('hud-era');
    this.judgmentEl = document.getElementById('hud-judgment');
    this.hintEl = document.getElementById('hud-hint');
    this.audioEl = document.getElementById('audio-status');
    this.audioButton = document.getElementById('btn-audio');
    this._judgmentTimer = 0;
  }

  show() {
    this.root?.classList.remove('hidden');
  }

  hide() {
    this.root?.classList.add('hidden');
  }

  reset() {
    this.update({ score: 0, combo: 0, progress: 0, energy: 0, overdrive: false });
    if (this.judgmentEl) {
      this.judgmentEl.textContent = '';
      this.judgmentEl.className = 'hud-judgment';
    }
  }

  setHint(text) {
    if (!this.hintEl) return;
    this.hintEl.textContent = String(text ?? '');
    this.hintEl.classList.remove('is-hidden');
  }

  clearHint() {
    this.hintEl?.classList.add('is-hidden');
  }

  setAudioState(ready, status = 'ready', message = '') {
    if (!this.audioEl) return;
    const isError = status === 'error';
    const isLoading = ['loading', 'starting', 'stalled'].includes(status);
    this.audioEl.textContent = isError
      ? (message || 'AUDIO ERROR')
      : isLoading
        ? 'LOADING AUDIO…'
        : ready
          ? COPY.audioReady
          : COPY.audioMuted;
    this.audioEl.classList.toggle('is-error', isError);
    this.audioEl.classList.toggle('is-muted', !ready && !isError);
    if (this.audioButton) {
      this.audioButton.textContent = ready ? 'MUTE' : 'UNMUTE';
      this.audioButton.setAttribute('aria-pressed', String(!ready));
    }
  }

  update({ score, combo, progress, energy = 0, overdrive = false, fever = false, era = 'VOID' }) {
    if (this.eraEl) {
      const eraText = fever ? `${era} · FEVER ×1.5` : era;
      if (this.eraEl.textContent !== eraText) this.eraEl.textContent = eraText;
      this.eraEl.classList.toggle('is-fever', fever);
    }
    if (this.scoreEl) this.scoreEl.textContent = String(Math.floor(score));
    if (this.comboEl) this.comboEl.textContent = `×${Math.floor(combo)}`;
    if (this.fillEl) this.fillEl.style.width = `${Math.max(0, Math.min(100, progress * 100))}%`;
    if (this.overdriveFillEl) {
      this.overdriveFillEl.style.width = `${Math.max(0, Math.min(100, energy))}%`;
      this.overdriveFillEl.classList.toggle('is-active', overdrive);
    }
    if (this.overdriveLabelEl) {
      this.overdriveLabelEl.classList.toggle('is-active', overdrive);
      this.overdriveLabelEl.textContent = overdrive ? 'OVERDRIVE ×2' : 'OVERDRIVE';
    }
  }

  flashJudgment(text, kind) {
    if (!this.judgmentEl) return;
    const allowed = new Set(Object.values(JUDGMENTS).map((j) => j.label));
    const label = allowed.has(text) ? text : JUDGMENTS.good.label;
    this.judgmentEl.textContent = label;
    this.judgmentEl.className = `hud-judgment is-show is-${kind}`;
    clearTimeout(this._judgmentTimer);
    this._judgmentTimer = setTimeout(() => {
      this.judgmentEl.classList.remove('is-show');
    }, 420);
  }
}
